var map = {
	"./BTC.svg": 4858,
	"./BUSD.svg": 2964,
	"./CHF.svg": 2089,
	"./CNY.svg": 525,
	"./ETH.svg": 2200,
	"./EUR.svg": 7194,
	"./GBP.svg": 9485,
	"./INR.svg": 9855,
	"./JPY.svg": 5950,
	"./KPW.svg": 7647,
	"./RUB.svg": 9538,
	"./TRX.svg": 1915,
	"./USD.svg": 8367,
	"./USDT.svg": 1262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1611;